// extracted by mini-css-extract-plugin
module.exports = {"tabRoot":"Tab_tabRoot__uXpcu","tabItem":"Tab_tabItem__3eC10"};